import { render, staticRenderFns } from "./BerkleyUnderwriter.vue?vue&type=template&id=0ad1c0fc"
import script from "./BerkleyUnderwriter.vue?vue&type=script&lang=js"
export * from "./BerkleyUnderwriter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports